import React, { useEffect, useState } from 'react'
import { CAMPAIGN } from '../config/campaign'

interface TimeLeft {
  days: number
  hours: number
  minutes: number
  seconds: number
}

function computeTimeLeft(): TimeLeft | null {
  const diff = CAMPAIGN.orderDeadline.getTime() - new Date().getTime()
  if (diff <= 0) return null
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  }
}

const TasteCountdown: React.FC = () => {
  const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(() => computeTimeLeft())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(computeTimeLeft())
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  if (!timeLeft) return null

  const boxes: { label: string; value: number }[] = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds },
  ]

  return (
    <div className="flex flex-col items-center text-center">
      <p className="text-xs md:text-sm font-semibold uppercase tracking-widest font-body mb-3 !text-white">
        Pre-order closes {CAMPAIGN.orderDeadlineDisplay} &mdash; ships by {CAMPAIGN.shipDateDisplay}
      </p>
      <div className="flex items-stretch justify-center gap-2 md:gap-3">
        {boxes.map((box) => (
          <div
            key={box.label}
            className="flex flex-col items-center justify-center rounded-xl bg-white/5 border border-white/10 px-3 py-2 md:px-4 md:py-3 min-w-[64px] md:min-w-[80px]"
          >
            <span className="text-2xl md:text-4xl font-bold font-heading tabular-nums leading-none !text-white">
              {String(box.value).padStart(2, '0')}
            </span>
            <span className="mt-1 text-[10px] md:text-xs font-semibold uppercase tracking-wider font-body !text-white/60">
              {box.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TasteCountdown
